<template>
  <div class="wc-row">
    <div class="wc-col wc-col__sm-12 wc-col__md-12">
      <RequestDigitalCardList></RequestDigitalCardList>
    </div>
  </div>
</template>

<script setup lang="ts">
import RequestDigitalCardList from '@/components/policy/self-services/RequestDigitalCardList.vue'
</script>
